export default "__VITE_ASSET__DPD4vf9a__"